import React, { ReactNode } from "react";
import { Link } from "react-router-dom";

import CopyableIdentifier from "./CopyableIdentifier";

type TraceableBarcodeProps = {
  barcode: string | number | null | undefined;
  displayValue?: ReactNode;
  historyType?: "item" | "mixed-carton";
  className?: string;
  valueClassName?: string;
};

export function buildBarcodeHistoryPath(
  barcode: string | number,
  historyType: "item" | "mixed-carton" = "item",
) {
  const searchParams = new URLSearchParams({ barcode: String(barcode) });
  const route =
    historyType === "mixed-carton"
      ? "/mixed-carton-history"
      : "/barcode-history";
  return `${route}?${searchParams.toString()}`;
}

/** A barcode that opens its lifecycle history while retaining the copy action. */
export default function TraceableBarcode({
  barcode,
  displayValue,
  historyType = "item",
  className,
  valueClassName,
}: TraceableBarcodeProps) {
  const value = barcode == null ? "" : String(barcode);
  const hasValue = value.trim().length > 0;

  return (
    <CopyableIdentifier
      value={barcode}
      description="full barcode"
      className={className}
      valueClassName={valueClassName}
      displayValue={
        hasValue ? (
          <Link
            to={buildBarcodeHistoryPath(value, historyType)}
            target="_blank"
            rel="noopener noreferrer"
            className="font-medium text-inherit underline decoration-slate-400 underline-offset-2 transition-colors hover:text-slate-700 focus-visible:rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-slate-500"
            title={`View ${historyType === "mixed-carton" ? "mixed carton" : "barcode"} history for ${value}`}
            onClick={(event) => event.stopPropagation()}
          >
            {displayValue ?? value}
          </Link>
        ) : undefined
      }
    />
  );
}
